export default __webpack_public_path__ + "static/media/hs2.ab3c211a.png";